import { useTranslations } from '@npco/utils-translations'

import { LEGAL_URL } from 'const/externalLinks'

import { savingsAccountBannerTranslations } from '../../SavingsAccountBanner.i18n'
import * as styled from '../../SavingsAccountBanner.styled'

export const TermsAndConditionsAnchor = () => {
  const t = useTranslations(savingsAccountBannerTranslations)

  return (
    <styled.Anchor href={LEGAL_URL} target="_blank" rel="noopener noreferrer">
      {t('anchor')}
    </styled.Anchor>
  )
}
